// src/components/IncomeEntryTable.tsx
import React from "react";
import { useTranslation } from "react-i18next";
import { ApplicationIncomeDto } from "../../api/services";
import { formatCurrency } from "../../utils/formatCurrency";

interface Props {
  entries: ApplicationIncomeDto[];
  onEdit: (e: ApplicationIncomeDto) => void;
  onDelete: (e: ApplicationIncomeDto) => void;
}

const IncomeEntryTable: React.FC<Props> = ({ entries, onEdit, onDelete }) => {
  const { t } = useTranslation();

  return (
    <table className="w-full text-sm">
      <thead className="border-b border-gray-200">
        <tr>
          <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-muted">{t("incomeEntryTable.type")}</th>
          <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-muted">{t("incomeEntryTable.jobTitle")}</th>
          <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-muted">{t("incomeEntryTable.company")}</th>
          <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-muted">{t("incomeEntryTable.income")}</th>
          <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-muted"></th>
        </tr>
      </thead>
      <tbody>
        {entries.map((e) => (
          <tr key={e.id}>
            <td className="px-4 py-3">{e.type}</td>
            <td className="px-4 py-3">{e.jobTitle}</td>
            <td className="px-4 py-3">{e.company}</td>
            <td className="px-4 py-3">{formatCurrency(e.monthlyNetIncome)}</td>
            <td className="px-4 py-3 text-right">
              <button className="rounded-md px-3 py-1.5 text-xs font-medium transition-colors bg-accent text-black hover:bg-accent-hover" onClick={() => onEdit(e)}>
                {t("incomeEntryTable.edit")}
              </button>{" "}
              <button
                className="rounded-md px-3 py-1.5 text-xs font-medium transition-colors text-danger hover:text-red-700"
                onClick={() => onDelete(e)}
              >
                {t("incomeEntryTable.delete")}
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default IncomeEntryTable;
